<template>
  <vs-collapse class="site-lists" accordion>
    <vs-collapse-item
      class="collapse-item"
      v-for="(bookmark, index) in list"
      :key="index"
      not-arrow
    >
      <div slot="header" class="site-item">
        <div class="flex items-center">
          <feather-icon icon="MapPinIcon" class="mx-3" />
          {{ bookmark.siteName }}
        </div>
        <div class="flex items-center">
          <div class="box-info bookmark-count">
            <div>Bookmark</div>
            <div class="flex items-center">
              <feather-icon icon="BookmarkIcon" class="m-0" />
              <div class="pl-2">{{ bookmark.cameraBookmark.length }}</div>
            </div>
          </div>
          <feather-icon class="icon-arrow" icon="ChevronDownIcon" />
        </div>
      </div>
      <div>
        <vs-table stripe :data="bookmark.cameraBookmark">
          <template slot="thead">
            <vs-th>No</vs-th>
            <vs-th class="text-left">Bookmark Name</vs-th>
            <vs-th class="text-left">Start Time</vs-th>
            <vs-th class="text-left">End Time</vs-th>
            <vs-th class="text-left">Description</vs-th>
            <vs-th class="text-right">&nbsp;</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="indextr">
                {{ indextr + 1 }}
              </vs-td>

              <vs-td class="text-left" :data="tr.name">
                {{ tr.name }}
              </vs-td>

              <vs-td class="text-left" :data="tr.startTime">
                {{ prettyDate(tr.startTime) }}
              </vs-td>

              <vs-td class="text-left" :data="tr.endTime">
                {{ prettyDate(tr.endTime) }}
              </vs-td>

              <vs-td class="text-left" :data="tr.description">
                {{ tr.description }}
              </vs-td>

              <vs-td class="text-right align-middle">
                <div class="flex space-x-2">
                  <router-link :to="`/bookmark/${tr.id}`" title="Show Bookmark">
                    <feather-icon icon="EyeIcon" svgClasses="icon" />
                  </router-link>
                  <button
                    role="button"
                    class="outline-none bg-transparent border-none p-0 cursor-pointer"
                    @click="$emit('update:item', tr)"
                  >
                    <feather-icon icon="EditIcon" svgClasses="icon" />
                  </button>
                  <button
                    role="button"
                    class="outline-none bg-transparent border-none p-0 cursor-pointer"
                    @click="$emit('delete:item', tr)"
                  >
                    <feather-icon icon="TrashIcon" svgClasses="icon" />
                  </button>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vs-collapse-item>
  </vs-collapse>
</template>

<script>
export default {
  props: ["list"],
  methods: {
    prettyDate(date) {
      const format = new Date(date);
      return new Intl.DateTimeFormat("ID", {
        dateStyle: "medium",
        timeStyle: "medium",
      }).format(format);
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  @apply text-blue w-6;
  &:hover {
    @apply text-primary;
  }
}
.collapse-item {
  @apply border-none mb-5;
  .icon-arrow {
    @apply transition-transform duration-300;
    color: #1372ac;
  }
  &.open-item {
    .icon-arrow {
      @apply transform rotate-180;
    }
  }
}
.text-center::v-deep .vs-table-text {
  @apply justify-center;
}
.text-right::v-deep .vs-table-text {
  @apply justify-end;
}
.in-out-info {
  @apply flex;
  .box {
    width: 250px;
    @apply mr-5 p-2.5 rounded-lg border-2 border-solid border-blue;
    &.toggle-chart {
      @apply cursor-pointer w-25;
    }
    .title {
      font-size: 14pt;
    }
    .value {
      font-size: 20pt;
      @apply font-bold;
    }
    .icon {
      @apply w-10 h-10 text-blue;
    }
  }
}
.site-lists {
  @apply p-0;
  .site-item {
    @apply -mx-3 flex justify-between items-center font-semibold pb-3 text-base;
    border-bottom: 1px solid #ddd;
    .box-info {
      @apply flex items-center justify-between mr-3 border border-solid py-1 px-3 h-8;
      border-color: #ccc;
      background-color: #eee;
      &.bookmark-count {
        @apply w-48;
      }
    }
  }
}
</style>
